import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-legals-header',
  imports: [NgOptimizedImage],
  templateUrl: './legals-header.html',
})
export class LegalsHeader {
  readonly title = input.required<string>();
}
